import ImageContainer from "../components/MainPage/ImageContainer"
import Header from "../components/common/Header"
import Footer from "../components/common/Footer"
import SubContent from "../components/MainPage/SubContent"
import useScrollReset from "../hooks/useScrollReset"

const MainPage = () => {
  useScrollReset()

  return (
    <>
      <Header />
      <ImageContainer />
      <SubContent />
      <Footer />
    </>
  )
}

export default MainPage
